module.exports = __webpack_public_path__ + "img/ABC_Erkundungsgruppe.28616cfa.svg";